import {Platform, StyleSheet} from 'react-native';
import {ITheme} from 'contexts/ThemeContext';

export default ({colors}: ITheme) => {
  return StyleSheet.create({
    defaultBackDropStyle: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.transparentPrimary,
    },
  });
};
